/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-up-2': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<path pid="0" d="M8.18 0L0 7.606v4.301l6.545-6.086V18h3.273V5.821l6.546 6.086V7.606L8.18 0z" _fill="#F4F2F2"/>'
  }
})
